import { CommonModule } from '@angular/common';
import { Component, effect, inject, signal } from '@angular/core';
import { SidebarItemComponent } from '../../molecules/sidebar-item/sidebar-item.component';
import { SidebarToggleComponent } from '../../atoms/sidebar-toggle/sidebar-toggle.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { AuthState } from '../../../../core/state/auth/auth.reducer';
import { Store } from '@ngrx/store';
import { selectIsAdmin, selectIsAdminOrModerator } from '../../../../core/state/user/user.selectors';
import { FeedbackDialogComponent } from '../../molecules/feedback-dialog/feedback-dialog.component';
import { createFeedback } from '../../../../core/state/feedback/feedback.actions';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, SidebarItemComponent, SidebarToggleComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  private store = inject(Store);
  private dialog = inject(MatDialog);
  isExpanded = signal(true); // Reactive signal for sidebar state
  hovered = false;

  hiddenRoutes = ['/login', '/register', '/']; // Pages where sidebar is hidden
  isHidden = signal(false); // Controls sidebar visibility

  screenWidth = signal(window.innerWidth);

  previousWidth = this.screenWidth();

  public isAdmin$: Observable<boolean>;
  public isAdminOrModerator$: Observable<boolean>;

  constructor(private router: Router, private authStore: Store<AuthState>) {
    // Automatically update sidebar visibility on route change
    effect(() => {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.isHidden.set(this.hiddenRoutes.includes(event.urlAfterRedirects));
      });
    });

    this.isAdmin$ = this.authStore.select(selectIsAdmin);
    this.isAdminOrModerator$ = this.authStore.select(selectIsAdminOrModerator);
  }

   // signal from service

   toggleSidebar() {
      this.isExpanded.update((expanded) => !expanded);
  }

  openFeedbackDialog(): void {
  const dialogRef = this.dialog.open(FeedbackDialogComponent, {
    width: '500px'
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.store.dispatch(createFeedback({ feedback: result }));
    }
  });
}
}
